export enum AuthClassification {
  ADMINISTRATOR = 'Administrator',
  OWNER_OPERATOR = 'Owner Operator',
  CONTENT_CREATOR = 'Content Creator',
  VIEWER = 'Viewer',
  NONE = 'None',
}
